import { sprintf } from "sprintf-js";
import { NETWORK_FAILURE } from './constants';

const Utils = {};

/**
 * Asserts that a premise is true.
 */
Utils.assertTrue = function(premise, message) {
  if (!premise) {
    throw new Error(message);
  }
};

/**
 * Asserts that a value is not null or undefined.
 */
Utils.assertNotNull = function(value, name) {
  Utils.assertTrue(
    value !== null && typeof value !== undefined,
    sprintf("%s must be provided", name || "A value")
  );
  return value;
};

Utils.isNonEmptyString = function(value) {
  return typeof value === "string" && value.length > 0;
};

Utils.assertIsList = function(value, key) {
  if (!Array.isArray(value)) {
    throw new Error(key + " is not an array");
  }
};

/**
 * Determine if the given value is a callable function type.
 * Borrowed from Underscore.js.
 */
Utils.isFunction = function(obj) {
  return !!(obj && obj.constructor && obj.call && obj.apply);
};

Utils.isObject = function(value) {
  return !(typeof value !== "object" || value === null);
};

Utils.isString = function(value) {
  return typeof value === "string";
};

Utils.isNumber = function(value) {
  return typeof value === "number";
};

const wsRegex = new RegExp("^(wss://)\\w*");
const localWsRegex = new RegExp("^(ws://127.0.0.1:)");
Utils.validWSUrl = function (wsUrl) {
  return wsRegex.test(wsUrl) || localWsRegex.test(wsUrl);
};

Utils.getSubscriptionResponse = (routeKey, isSuccess, topicList) => {
  return {
    topic: routeKey,
    content : {
      status: isSuccess ? "success" : "failure",
      topics: topicList
    }
  };
};

Utils.assertIsObject = function(value, key) {
  if (!Utils.isObject(value)) {
    throw new Error(key + " is not an object!");
  }
};

Utils.addJitter = function (base, maxJitter = 1) {
  maxJitter = Math.min(maxJitter, 1.0);
  const sign = Math.random() > 0.5 ? 1 : -1;
  return Math.floor(base + sign * base * Math.random() * maxJitter);
};

Utils.isNetworkOnline = () => navigator.onLine;

Utils.isNetworkFailure = (reason) => {
  if(reason._debug && reason._debug.type) {
    return reason._debug.type === NETWORK_FAILURE;
  }
  return false;
};

export default Utils;
